module.exports = __webpack_public_path__ + "img/n.2914a42b.jpg";